<template>
  <FavoritesList :entity-type="EntityType.Post" />
</template>

<script setup lang="ts">
import { EntityType } from '~/models/common'
import { useNavigation } from '~/stores/navigation'

const { fetchCategories } = useNavigation()

onBeforeMount(async () => {
  await fetchCategories()
})
</script>
